// ============================================================
// CENTRAL PLAN CONFIGURATION
// ============================================================
// The ONLY place plan limits/capabilities are defined. Every feature
// (chat, exports, reports, upload) reads from here via
// SubscriptionContext — nothing hardcodes a limit or a capability check
// anywhere else in the app.

export const FREE_MONTHLY_ANALYSIS_LIMIT = 5;
export const PREMIUM_MONTHLY_ANALYSIS_LIMIT = 500; // "significantly higher" — configurable here only

export const PLANS = {

  free: {
    id: "free",
    name: "Free",
    priceMonthly: 0,
    priceLabel: "$0",
    priceSuffix: "/month",
    monthlyAnalysisLimit: FREE_MONTHLY_ANALYSIS_LIMIT,
    maxFileSizeMB: 10,
    maxRows: 5000,
    canExportCharts: true,
    canExportFullChat: true,
    canGenerateReports: true,
    canGenerateExecutiveSummary: true,
    hasWatermark: true,
    canSaveSessions: true,
    canScheduleReports: false,
    maxScheduledReports: 0,
  },

  premium: {
    id: "premium",
    name: "Premium",
    priceMonthly: 10,
    priceLabel: "$10",
    priceSuffix: "/month",
    monthlyAnalysisLimit: PREMIUM_MONTHLY_ANALYSIS_LIMIT,
    maxFileSizeMB: 100,
    maxRows: 200_000,
    canExportCharts: true,
    canExportFullChat: true,
    canGenerateReports: true,
    canGenerateExecutiveSummary: true,
    hasWatermark: false,
    canSaveSessions: true,
    canScheduleReports: true,
    maxScheduledReports: 20,
  },

};

// Scheduled reports accept at most this many recipient email addresses
// per schedule, regardless of plan.
export const MAX_SCHEDULE_RECIPIENTS = 10;

export function getPlanCapabilities(planId) {
  return PLANS[planId] || PLANS.free;
}

// "YYYY-MM" — the usage tracking period. A new period means a fresh count.
export function currentPeriod() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
}

// First day of NEXT month — shown to the user as "resets on".
export function nextResetDate() {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth() + 1, 1);
}
